import React, { useState } from 'react';
import RowUser from '../components/UserRows';
import NotTheApplicationUsers from '../hooks/UsersNotTheApplication';
import useUserLength from '../hooks/UseUsersLenght';
import { utils, writeFile } from 'xlsx';

const ListUsers = () => {
    const { notTheApplicationUsers, loading, error: usersError, reloadData } = NotTheApplicationUsers();
    const { userLength } = useUserLength();
    const [roleFilter, setRoleFilter] = useState('all');
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const filteredUsers = notTheApplicationUsers.filter(user => {
        return (roleFilter === 'all' || user.User.role === roleFilter);
    });

    const sortedUsers = [...filteredUsers].sort((a, b) => {
        if (!sortColumn) return 0;

        let aValue, bValue;

        switch (sortColumn) {
            case 'userId':
                aValue = a.User.userId;
                bValue = b.User.userId;
                break;
            case 'firstName':
                aValue = a.User.firstName;
                bValue = b.User.firstName;
                break;
            case 'username':
                aValue = a.User.username;
                bValue = b.User.username;
                break;
            case 'role':
                aValue = a.User.role;
                bValue = b.User.role;
                break;
            case 'pollAnswer':
                aValue = a.Poll.pollAnswer;
                bValue = b.Poll.pollAnswer;
                break;
            case 'userTimeStart':
                aValue = new Date(a.User.userTimeStart);
                bValue = new Date(b.User.userTimeStart);
                break;
            case 'isBlocked':
                aValue = a.User.isBlocked;
                bValue = b.User.isBlocked;
                break;
            case 'userTimeBlock':
                aValue = a.User.userTimeBlock ? new Date(a.User.userTimeBlock) : null;
                bValue = b.User.userTimeBlock ? new Date(b.User.userTimeBlock) : null;
                break;
            default:
                aValue = a[sortColumn];
                bValue = b[sortColumn];
        }

        if (aValue == null) return sortDirection === 'asc' ? 1 : -1;
        if (bValue == null) return sortDirection === 'asc' ? -1 : 1;
        if (aValue == null && bValue == null) return 0;

        if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const resetFilters = () => {
        setRoleFilter('all');
        setSortColumn(null);
        setSortDirection('asc');
    };

    const exportToExcel = (data) => {
        const filteredData = data.map(user => ({
            'User ID': user.User.userId,
            'Имя': user.User.firstName,
            'Никнейм': user.User.username,
            'Роль': user.User.role === 'user' ? 'Пользователь' : 'Админ',
            'Результат опроса': user.Poll.pollAnswer === 'other_course' ? 'Прохожу другой курс' : 
                              user.Poll.pollAnswer === 'superhuman' ? 'Прохожу Superhuman' : 'Не прохожу курсов',
            'Дата регистрации': new Date(user.User.userTimeStart).toLocaleString(),
            'Активность': user.User.isBlocked === true ? 'Блокировка' : 'Активен',
            'Дата блокировки пользователем': user.User.userTimeBlock != null ? 
                                          new Date(user.User.userTimeBlock).toLocaleString() : '---',
        }));
    
        const worksheet = utils.json_to_sheet(filteredData);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Пользователи');
        writeFile(workbook, 'Пользователи.xlsx');
    };

    if (loading) return <div className="loading"><p>Загрузка...</p></div>;

    return (
        <div className="user-list-container">
            <h2>Список пользователей</h2>

            <div className="controls">
                <div className="filter-group">
                    <label htmlFor="roleFilter">
                        Роль:
                        <select
                            id="roleFilter"
                            value={roleFilter}
                            onChange={(e) => setRoleFilter(e.target.value)}
                        >
                            <option value="all">Все роли</option>
                            <option value="user">Пользователь</option>
                            <option value="admin">Администратор</option>
                        </select>
                    </label>
                </div>

                <div className="action-buttons">
                    <button onClick={resetFilters} className="reset-btn">
                        Сбросить фильтры
                    </button>
                    <button 
                        onClick={() => exportToExcel(filteredUsers)} 
                        className="export-btn"
                        disabled={!filteredUsers || filteredUsers.length === 0}
                    >
                        Экспорт в Excel
                    </button>
                </div>
            </div>

            {filteredUsers.length > 0 ? (
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th onClick={() => handleSort('courseNumber')}>
                                    № {sortColumn === 'courseNumber' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('userId')}>
                                    User ID {sortColumn === 'userId' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('firstName')}>
                                    Имя пользователя {sortColumn === 'firstName' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('username')}>
                                    Никнейм {sortColumn === 'username' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('role')}>
                                    Роль {sortColumn === 'role' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('pollAnswer')}>
                                    Результат опроса {sortColumn === 'pollAnswer' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('userTimeStart')}>
                                    Дата регистрации {sortColumn === 'userTimeStart' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('isBlocked')}>
                                    Активность {sortColumn === 'isBlocked' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                                <th onClick={() => handleSort('userTimeBlock')}>
                                    Дата блокировки {sortColumn === 'userTimeBlock' && (
                                        sortDirection === 'asc' ? '↑' : '↓'
                                    )}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedUsers.map((user, index) => (
                                <RowUser
                                    key={user.id}
                                    id={user.id}
                                    userId={user.User.userId}
                                    firstName={user.User.firstName}
                                    username={user.User.username}
                                    role={user.User.role}
                                    poll={user.Poll.pollAnswer}
                                    dataReg={new Date(user.User.userTimeStart).toLocaleString()}
                                    isBlocked={user.User.isBlocked}
                                    dataBlock={user.User.userTimeBlock}
                                    courseNumber={index + 1}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>User ID</th>
                                <th>Имя пользователя</th>
                                <th>Никнейм</th>
                                <th>Роль</th>
                                <th>Результаты опроса</th>
                                <th>Дата регистрации</th>
                                <th>Активность</th>
                                <th>Дата блокировки</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="9" className="no-data">
                                    Нет пользователей для отображения
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <style>{`
                .user-list-container {
                    padding: 20px;
                    font-family: Arial, sans-serif;
                    max-width: 1200px;
                    margin: 0 auto;
                }
                
                h2 {
                    margin-bottom: 20px;
                    color: #333;
                }
                
                .controls {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    flex-wrap: wrap;
                    gap: 15px;
                    background: #f8f9fa;
                    padding: 15px;
                    border-radius: 8px;
                }
                
                .filter-group {
                    display: flex;
                    gap: 15px;
                    flex-wrap: wrap;
                    align-items: flex-end;
                }
                
                .filter-group label {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                    font-size: 14px;
                }
                
                .filter-group input, .filter-group select {
                    padding: 8px 12px;
                    border: 1px solid #ced4da;
                    border-radius: 4px;
                    font-size: 14px;
                }
                
                .action-buttons {
                    display: flex;
                    gap: 10px;
                    align-items: flex-end;
                }
                
                button {
                    padding: 8px 16px;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s;
                    font-size: 14px;
                }
                
                button:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
                
                .reset-btn {
                    background-color: #6c757d;
                    color: white;
                }
                
                .export-btn {
                    background-color: #28a745;
                    color: white;
                }
                
                button:hover:not(:disabled) {
                    opacity: 0.9;
                    transform: translateY(-1px);
                }
                
                .table-container {
                    overflow-x: auto;
                    border-radius: 8px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.05);
                }
                
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                    background: white;
                }
                
                th, td {
                    padding: 12px 15px;
                    text-align: left;
                    border-bottom: 1px solid #dee2e6;
                }
                
                th {
                    background-color: #f8f9fa;
                    cursor: pointer;
                    position: relative;
                    font-weight: 600;
                    color: #495057;
                }
                
                th:hover {
                    background-color: #e9ecef;
                }
                
                tr:hover {
                    background-color: #f8f9fa;
                }
                
                .no-data {
                    text-align: center;
                    color: #6c757d;
                    padding: 20px;
                }
                
                .loading {
                    padding: 20px;
                    text-align: center;
                    background: #f8f9fa;
                    border-radius: 8px;
                    margin: 20px 0;
                }
                
                @media (max-width: 768px) {
                    .controls {
                        flex-direction: column;
                    }
                    
                    .action-buttons {
                        justify-content: flex-end;
                    }
                    
                    th, td {
                        padding: 8px 10px;
                        font-size: 14px;
                    }
                }
            `}</style>
        </div>
    );
};


export default ListUsers;